<template>
    <div class="GoodDetails">
        <Header ref="headRef"></Header>
        <div style="width: 1000px;overflow: hidden;overflow-y: auto;scrollbar-width: none; " :style="{
            'margin-left': innerWidth > 1000 ? (innerWidth - 1000) / 2 + 'px' : '0px',
            'height': (innerHeight - 70 - 68) + 'px'
        }">
            <div class="shop_wrap">
                <div class="banner_wrap fl">

                    <img class="banner_img" :src="good.photos[0].url">
                </div>
                <div class="shop_pane fr">
                    <div class="course_title over_2">{{good.goodsName}}</div>

                    <div style="min-height: 150px;">
                        <div class="courseTeacherList" >
                            <img :src="teacher.avatarUrl"  v-for="(teacher, teacherIndex) in good.teacherList" :key="teacherIndex" class="courseTeacherImg">
                        </div>
                        <div v-for="(specGroup, specGroupIndex) in good.specGroupList" :key="specGroupIndex">
                            <div class="type ">{{ specGroup.specName }}</div>
                            <ul class="tag_list">
                                <li class="tag  " :class="specItem.specId == spec.specId ? 'active' : ''"
                                    @click="chooseSpec(specItem)" v-for="(specItem, specIndex) in specGroup.specList"
                                    :key="specIndex">
                                    {{ specItem.specAttribute }}
                                </li>
                            </ul>
                        </div>

                    </div>
                    <hr>
                    <div class="btnWrap">
                        <div class="price_area">
                            <div class="price_wrap fl">
                                <span class="unit">￥</span>
                                <span class="price">{{ (spec.price / 100).toFixed(2) }}</span>
                                <span class="unit">元</span>
                            </div>
                            <el-button style="float: right;" type="danger" @click="goOrderDet">立即购买</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div style="width: 100%;margin-top: 350px;clear: both;">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="详情" name="first">
                        <div style="" v-html="good.goodsDetails"></div>
                    </el-tab-pane>
                    <el-tab-pane label="讲师" name="second">
                        <a target="_blank" @click="goDetail(teacher.teacherId)" v-for="(teacher, index) in good.teacherList"
                            :key="index" class="teacherItem">
                            <div class="teacherImg"><img :src="teacher.avatarUrl" alt=""></div>
                            <div class="teacherContent" style="margin-left: 15px;">
                                <div style=" line-height: 40px;font-size: 18px;font-weight: 600;">
                                    {{ teacher.name }}
                                </div>
                                <div class="scroll">
                                    <div class="teacherDescription">
                                        {{ teacher.intro }}
                                    </div>
                                </div>
                            </div>
                        </a>

                    </el-tab-pane>

                </el-tabs>
            </div>

        </div>
        <Suspension></Suspension>
        <Footer></Footer>
    </div>
</template>

<script>

import Header from "../../components/common/Header"
import Footer from "../../components/common/Footer"
import Suspension from "../../components/common/Suspension"

import {
    // getByUrl,
    getByParam
} from '@/api/api.js';

import {
    getCookie,
    setLocalStorage
} from '@/utils/util.js';


export default {
    name: "GoodDetails",
    components: {
        Header,
        Footer,
        Suspension
    },
    data() {
        return {
            good: {},
            spec: {},
            coverImg: '',
            activeName: 'first',
            innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        }
    },
    mounted() {
        console.log(this.$route.query.id);
        this.getGoodDetails(this.$route.query.id);
    },
    methods: {
        goDetail(id){
            this.$router.push({
                path: '/teacher/det',
                query: {
                 id: id
                }
            })
        },
        chooseSpec(item) {
            this.spec = item;
        },
        goOrderDet() {

            var token = getCookie('token')
            if (token) {
                this.good.chooseSpec = this.spec
                setLocalStorage('goodInfo',JSON.stringify(this.good))
                this.$router.push({
                    path: '/order/det',
                })
            } else {
                this.$refs.headRef.showLogin();
            }
        },
        getGoodDetails(id) {
            let param = {
                goodsId: id
            }
            getByParam('/web/mall/goods/detail', param).then(res => {
                console.log(res);

                this.good = res.data;
                this.coverImg = res.data.photos[0].url;

                if (this.good.specGroupList) {
                    this.spec = this.good.specGroupList[0].specList[0];
                }

                console.log('coverImg', this.coverImg);
            })
        }
    }
}
</script>
<style scoped>
.shop_wrap {
    width: 1000px;
    margin: 30px auto;
}

.banner_list {
    border: 1px solid #ededed;
}

.banner_wrap {
    height: 270px;
    width: 480px;
}

.banner_img {
    width: 100%;
    height: 100%;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
}

.shop_pane {
    width: 490px;
}

.course_title {
    font-size: 18px;
    line-height: 22px;
    font-weight: 700;
    /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; */
}

.price_area {
    padding: 10px;
    background-color: #f7f7f7;
    border-radius: 8px;
}

.price_wrap {
    margin-top: 3px;
    color: #f2460c;
    font-size: 12px;
}

.unit {
    font-weight: 600;
    vertical-align: -webkit-baseline-middle;
}

.price {
    font-size: 24px;
    font-weight: 600;
    vertical-align: middle;
}

.type {
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    margin-top: 20px;
}

.tag_list {
    font-size: 0;
    margin-left: -10px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.tag {
    margin-top: 10px;
    margin-left: 10px;
    display: inline-block;
    max-width: 238px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 31px;
    background-color: #f7f7f7;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    color: #7f7f7f;
    font-size: 12px;
    letter-spacing: 0;
    padding: 0 10px;
    cursor: pointer;
}

.active {
    background-color: #f2460c;
    color: #fff;
    border-color: #f2460c;
}

hr {
    border-width: 0;
    border-top: 1px solid #ededed;
    margin: 20px 0;
}

.courseLabelList {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    max-height: 112px;
    overflow: hidden;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    margin-top: 8px;
}

.singleLabel {
    font-size: 12px;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    /* height: 20px; */
    margin: 0 8px 8px 0;
    border: .5px solid rgba(242, 132, 48, .30196078431372547);
    padding: 4px 6px;
    border-radius: 4px;
    background: rgba(242, 132, 48, .03137254901960784);
    color: #f28430;
    line-height: 12px;
    font-weight: 500;
}

.tabs {
    width: 100%;
    border-bottom: 1px solid #e9e9e9;
    position: relative;

    height: 48px;
    line-height: 48px;
}

.tabLine {
    position: absolute;
    left: 0;
    top: 48px;
    border-radius: 4px;
    background-color: #05c1b7;
    -webkit-transition: .3s;
    transition: .3s;
}

.courseTeacherList {
    display: flex;
    margin-top: 10px;
}

.courseTeacherImg {
    display: inline-block;
    width: 44px;
    height: 44px;
    margin: 0 12px 0 0;
    border-radius: 50%;
}

.teacherItem {
    margin-top: 20px;
    cursor: pointer;
    height: 180px;
    overflow: hidden;
    padding: 24px;
    display: flex;
    border-radius: 10px;
    border: 1px solid #ededed;
    box-sizing: border-box;
    /* background: #fff; */
}

.teacherImg {
    flex-shrink: 0;
   
    margin-right: 24px;
        width: 120px;
    height: 120px;
    overflow: hidden;
    border-radius: 50%;
}

.teacherImg img {
    border-radius: 4px;
    width: 100%;
    height: 100%;
    display: block;
}
</style>